const getters = {    
    getItemsDashboard(state){
        return state.itemsDashboard
    },
    getRlImageCloseDialog(state){
        return state.rlImageCloseDialog
    },  
    getRlEntryAddDialogView2(state){
        return state.rlEntryAddDialogView2
    },
    getRlImageSaveDialog(state){
        return state.rlImageSaveDialog
    },
    getErrorMessage(state) {
        return state.errorMessage
    },
    getRlEditNote(state) {
        return state.rlEditNote
    },
    getRlEntry(state) {
        return state.rlEntry
    },
    getRlEntryList(state) {
        return state.rlEntryList
    },
    getRlEntryTable(state) {
        return state.rlEntryTable
    },
    getRlEntryTableOptions(state)  {
        return state.rlEntryTableOptions
    },
    getRlAddDialog(state) {
        return state.rlAddDialog
    },
    getRlAddDialogList(state) {
        return state.rlAddDialogList
    },
    getRlEditDialog(state) {
        return state.rlEditDialog
    },
    getRlDeleteDialog(state) {
        return state.rlDeleteDialog
    },
    getRlDialogRules(state) {
        return state.rlDialogRules
    },
    getRlImageAddDialog(state) {
        return state.rlImageAddDialog
    },
    getRlImageEditDialog(state) {
        return state.rlImageEditDialog
    },
    getRlImageFullSizeDialog(state) {
        return state.rlImageFullSizeDialog
    },
    getUser(state) {
        return state.user
    },
    getLoginAlert(state) {
        return state.loginAlert
    },
    getLicenseList(state){
        return state.licenseList
    },
    getRoleList(state) {
        return state.roleList
    },
    getPermssionList(state) {
        return state.permissionList
    },
    getEntryTypeList(state) {
        return state.entryTypeList
    },
    getMaterialList(state) {
        return state.materialList
    },
    getGradeList(state) {
        return state.gradeList
    },
    getIncotermList(state) {
        return state.incotermList
    },
    getCurrencyList(state) {
        return state.currencyList
    },
    getHs2List(state) {
        return state.hs2List
    },
    getDomesticCompanyList(state) {
        return state.domesticCompanyList
    },
    getShippingCompanyList(state) {
        return state.shippingCompanyList
    },
    getInspectionCompanyList(state) {
        return state.inspectionCompanyList
    },
    getCountryList(state) {
        return state.countryList
    },
    getUnitOfMeasureList(state) {
        return state.unitOfMeasureList
    },
    getRecyclingLedgerEntryList(state) {
        return state.recyclingLedgerEntryList
    },
    getCompanyList(state) {
        return state.companyList
    },
    getPBIReportList(state) {
        return state.pbiReportList
    },
    getPBITokenList(state) {
        return state.pbiTokenList
    },
    getShowVerificationMessage(state) {
        return state.showVerificationMessage
    }
}

export default getters;